export default __webpack_public_path__ + "static/media/product-8.ab80bb7c.png";